<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="correspondenceActionPartyForm">
      <div class="">
        <h3 class="form_name">Correspondence Action Party</h3>


          <div class="input">
            <label for="">Action Party</label>
             <select class="default_input reference-form" formControlName="StaffId" (change)="onSelectStaff($event.target.value)" style="width: 100%">
                <option value=""> Select Staff </option>
                    <option *ngFor="let staff of correspondencestaff" [value]="staff.id">
                     {{staff.StaffName}}
                    </option>
            </select>

            <label for="">Focal Point</label>
            <select class="default_input reference-form" formControlName="CorrespondenceTeamId" #team style="width: 100%">
                <option value=""> Select Focal Point</option>
                    <option *ngFor="let team of correspondenceteam" [value]="team.id">
                     {{team.CorrespondenceTeamName}}
                    </option>
            </select>

          </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(correspondenceActionPartyForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(correspondenceActionPartyForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Correspondence Action Party"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 

          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(correspondenceactionpartys | filterReference: control.value) as result"
              >
                <app-option
                  (click)="setCorrespondenceActionParty(option.id)"
                  *ngFor="let option of result"
                  [value]="option.StaffId"
                  [value]="option.CorrespondenceTeamId"
                >

                   {{ option.StaffId }}
                   {{ option.CorrespondenceTeamId }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>

        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Correspondence Action Party</span>
          <span class="item">Email</span>
          <span class="item">Correspondence Team</span>
          <span class="item">Action</span>

        </div>

      <div class="scroll">

      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let correspondenceactionparty of correspondenceActionPartyFormArray.get('CorrespondenceActionPartys')['controls']; index as i"
        (click)="onEdit(i, correspondenceactionparty.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{correspondenceactionparty.value.CorrespondenceActionPartyName}}</span>
          <span class="content">{{correspondenceactionparty.value.Email}}</span>
          <span class="content">{{getTeamName(correspondenceactionparty.value.CorrespondenceTeamId)}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"

            (click)="deleteCorrespondenceActionParty(i, correspondenceactionparty.value)">
            <em class="ti-trash"> </em> </button>
          </span>

        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(correspondenceActionPartyFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>

  <div class="box green_box"></div>
  <div class="box pink_box"></div>
